module.exports = __webpack_public_path__ + "img/spin_btn.ee4d7f34.png";